module.exports = __webpack_public_path__ + "img/completed-15.02a6a88d.svg";